import { render, staticRenderFns } from "./CollectionSlider.vue?vue&type=template&id=1679bdd2&scoped=true&lang=html&"
import script from "./CollectionSlider.vue?vue&type=script&lang=js&"
export * from "./CollectionSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1679bdd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1679bdd2')) {
      api.createRecord('1679bdd2', component.options)
    } else {
      api.reload('1679bdd2', component.options)
    }
    module.hot.accept("./CollectionSlider.vue?vue&type=template&id=1679bdd2&scoped=true&lang=html&", function () {
      api.rerender('1679bdd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionSlider.vue"
export default component.exports